import type { Spx } from '@wix/thunderbolt-becky-types'

/**
 * These constants are a temporary hack!
 * In the future we will have refWidth related to varianteable theme, which will include the spx.
 * BUT- for now, and for editor 3 specifically, this is enough.
 */

export const DESKTOP_SPX: Spx = {
	refWidth: 1280,
	resolverType: 'scale'
}

export const MOBILE_SPX: Spx = {
	refWidth: 390,
	resolverType: 'scale'
}
